// Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../services/AuthContext';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const { user } = useAuth();

  const menuItems = [
    {
      path: '/',
      icon: 'fas fa-tachometer-alt',
      label: 'Dashboard'
    },
    {
      path: '/products',
      icon: 'fas fa-boxes',
      label: 'Products'
    },
    {
      path: '/delivery',
      icon: 'fas fa-truck',
      label: 'Delivery Challan'
    },
    {
      path: '/reports',
      icon: 'fas fa-chart-bar',
      label: 'Reports'
    }
  ];

  // Add Users menu item only for admin users
  if (user?.role === 'admin') {
    menuItems.push({
      path: '/users',
      icon: 'fas fa-users',
      label: 'User Management'
    });
  }

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <div 
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={toggleSidebar}
      ></div>
      
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={`sidebar-link ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => window.innerWidth < 768 && toggleSidebar()}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;